import { render, staticRenderFns } from "./edc-submitted-form.vue?vue&type=template&id=839e73b4&scoped=true&"
import script from "./edc-submitted-form.vue?vue&type=script&lang=js&"
export * from "./edc-submitted-form.vue?vue&type=script&lang=js&"
import style0 from "./edc-submitted-form.vue?vue&type=style&index=0&id=839e73b4&scoped=true&lang=scss&"
import style1 from "./edc-submitted-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839e73b4",
  null
  
)

component.options.__file = "edc-submitted-form.vue"
export default component.exports